import { createGlobalStyle } from 'styled-components';
import { mediaDevices } from 'theme/theme.config.ts';

export const GlobalStyle = createGlobalStyle`
  .ant-input-outlined:focus-within {
    box-shadow: none !important;
  }

  .ant-select-focused .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-open .ant-select-selector {
    box-shadow: none !important;
  }
  
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    -webkit-tap-highlight-color: transparent;
  }

  html {
    height: 100%;
  }
  
  body {
    margin: 0;
    padding: 0;
    background: ${props => props.theme.themeV3.colors.grey50};
    font-family: "Plus Jakarta Sans", sans-serif;
    height: 100%;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;

    @media ${mediaDevices.tablet} {
      font-size: 18px;
    }
  }

  #root {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  a {
    color: ${props => props.theme.themeV3.colors.green400};
    text-decoration: none;
    
    &:hover {
      color: ${props => props.theme.themeV3.colors.green300};
      text-decoration: none;
    }
  }
  
  h1 {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 36px;
    color: ${props => props.theme.themeV3.colors.grey700};
    font-variant-numeric: lining-nums proportional-nums;

    @media ${mediaDevices.tablet} {
      font-size: 30px;
      line-height: 38px;
    }
  }

  h2 {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    font-variant-numeric: lining-nums tabular-nums;
    color: ${props => props.theme.themeV3.colors.grey700};

    @media ${mediaDevices.tablet} {
      font-size: 26px;
      line-height: 34px;
    }
  }

  h3 {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    font-variant-numeric: lining-nums tabular-nums;
    color: ${props => props.theme.themeV3.colors.grey700};

    @media ${mediaDevices.tablet} {
      font-size: 22px;
      line-height: 30px;
    }
  }

  h4 {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    font-variant-numeric: lining-nums tabular-nums;
    color: ${props => props.theme.themeV3.colors.grey700};

    @media ${mediaDevices.tablet} {
      font-size: 18px;
      line-height: 26px;
    }
  }
  
  p.p1 {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    font-variant-numeric: lining-nums proportional-nums;
    color: ${props => props.theme.themeV3.colors.grey700};

    @media ${mediaDevices.tablet} {
      font-size: 18px;
      line-height: 26px;
    }
  }

  p.p2 {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    font-variant-numeric: lining-nums proportional-nums;
    color: ${props => props.theme.themeV3.colors.grey700};

    @media ${mediaDevices.tablet} {
      font-size: 18px;
      line-height: 26px;
    }
  }

  p.p3 {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    font-variant-numeric: lining-nums tabular-nums;
    color: ${props => props.theme.themeV3.colors.grey700};

    @media ${mediaDevices.tablet} {
      font-size: 16px;
      line-height: 24px;
    }
  }

  p.p4 {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    font-variant-numeric: lining-nums tabular-nums;
    color: ${props => props.theme.themeV3.colors.grey700};

    @media ${mediaDevices.tablet} {
      font-size: 14px;
      line-height: 22px;
    }
  }

  .ant-message {
    .ant-message-notice-wrapper {
      .ant-message-notice {
        .ant-message-notice-content {
          padding: 8px 16px;
          border-radius: 10px;
          background: ${props => props.theme.themeV3.colors.grey200};

          .ant-message-custom-content {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 8px;
            color: ${props => props.theme.themeV3.colors.grey700};
            font-variant-numeric: lining-nums tabular-nums;
            font-family: "Plus Jakarta Sans", sans-serif;
            font-size: 14px;
            font-weight: 500;
            line-height: 22px;

            @media ${mediaDevices.tablet} {
              font-size: 16px;
              line-height: 24px;
            }
            
            &.ant-message-loading {
              .anticon {
                color: #5FCF80;
              }
            }
          }
        }
      }
    }
  }
  
  .ant-picker-dropdown {
    z-index: 9999999;
    color: ${props => props.theme.themeV3.colors.grey700} !important;
    font-variant-numeric: lining-nums tabular-nums !important;
    font-family: "Plus Jakarta Sans", sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;

    @media ${mediaDevices.tablet} {
      font-size: 16px !important;
    }
    
    .ant-picker-cell {
      .ant-picker-cell-inner {
        border-radius: 16px;
      }
      
      &.ant-picker-cell-selected {
        .ant-picker-cell-inner {
          background: ${props => props.theme.themeV3.colors.green400} !important;
        }
      }
      
      &.ant-picker-cell-today {
        .ant-picker-cell-inner {
          &:before {
            border-color: ${props => props.theme.themeV3.colors.green400} !important;
          }
        }
      }
    }
  }
  
  .ant-message {
    top: inherit !important;
    bottom: 50% !important;
  }
`;
